import { css } from 'react-emotion';

const heading = css`
	margin: 4px auto;
	font-weight: 600;
	line-height: 16px;
	font-size: 16px;
`;

const subHeading = css`
	margin: -2px auto 2px;
	font-size: 13px;
	color: #777;
`;

export { heading, subHeading };
